import { sumBy } from 'lodash';
import styled from 'styled-components/macro';
import { Table, TBody, Th, Tr } from '../../../shared/Table';
import { CoilDiameterRow } from '../../shared/manifold-table/CoilDiameterRow';
import { CoilLengthRow } from '../../shared/manifold-table/CoilLengthRow';
import { CoilQuantityRow } from '../../shared/manifold-table/CoilQuantityRow';
import { CutLengthRow } from '../../shared/manifold-table/CutLengthRow';
import { FloorCoveringRow } from '../../shared/manifold-table/FloorCoveringRow';
import { FloorSensorRow } from '../../shared/manifold-table/FloorSensorRow';
import { FloorTemperatureLimit } from '../../shared/manifold-table/FloorTemperatureLimit';
import { HeatLossRow } from '../../shared/manifold-table/HeatLossRow';
import { HeatOutputRow } from '../../shared/manifold-table/HeatOutputRow';
import { MaxDesignFloorTemperature } from '../../shared/manifold-table/MaxDesignFloorTemperature';
import { MinimumFlowRateRow } from '../../shared/manifold-table/MinimumFlowRateRow';
import { PortsRow } from '../../shared/manifold-table/PortsRow';
import { PressureLossRow } from '../../shared/manifold-table/PressureLossRow';
import { RemoteAirSensorRow } from '../../shared/manifold-table/RemoteAirSensorRow';
import { RoomNameRow } from '../../shared/manifold-table/RoomNameRow';
import { RoomTemperatureRow } from '../../shared/manifold-table/RoomTemperatureRow';
import { ShortfallRow } from '../../shared/manifold-table/ShortfallRow';
import { ThermostatRow } from '../../shared/manifold-table/ThermostatRow';
import { DataForDesignDrawingsManifold } from './dataForDesignDrawingsResponse';

type Props = { manifold: DataForDesignDrawingsManifold };
export const ManifoldTable = ({ manifold }: Props) => {
  const numberOfPorts = sumBy(manifold.rooms, room => room.numberOfPorts);

  return (
    <AutoWidthTable>
      <TBody>
        <Tr>
          <Th colSpan={numberOfPorts + 1}>
            {manifold.name} ({manifold.flowTemperatureInDegreesCelsius}&deg;C flow temperature)
          </Th>
        </Tr>
        <PortsRow numberOfPorts={numberOfPorts} />
        <RoomNameRow manifold={manifold} />
        <ThermostatRow manifold={manifold} />
        <FloorSensorRow manifold={manifold} />
        {/*RemoteAirSensorRow was erroneously doubled up originally and now the spreadsheet depends on it, please don't change!*/}
        <RemoteAirSensorRow manifold={manifold} />
        <RemoteAirSensorRow manifold={manifold} />
        <CoilQuantityRow manifold={manifold} />
        <CoilDiameterRow manifold={manifold} />
        <CoilLengthRow manifold={manifold} />
        <CutLengthRow manifold={manifold} />
        <MinimumFlowRateRow manifold={manifold} />
        <PressureLossRow manifold={manifold} />
      </TBody>
      <TBody>
        <Tr>
          <Th colSpan={numberOfPorts + 1}>Heat Loss and Outputs</Th>
        </Tr>
        <RoomTemperatureRow manifold={manifold} />
        <HeatLossRow manifold={manifold} />
        <HeatOutputRow manifold={manifold} />
        <FloorCoveringRow manifold={manifold} />
        <FloorTemperatureLimit manifold={manifold} />
        <MaxDesignFloorTemperature manifold={manifold} />
        <ShortfallRow manifold={manifold} />
      </TBody>
    </AutoWidthTable>
  );
};

const AutoWidthTable = styled(Table)`
  width: auto;
`;
